const common = {
  "user": {
    "unknown": "(Unknown)"
  },
  "queryState": {
    "imageLoading": "Loading image",
    "retry": "Retry",
    "loadFailedGeneric": "Failed to load data",
  },
  "reviewMode": {
    "label": "Review mode",
    "exit": "Exit review mode",
  },
  "notCompleted": {
    "view3d": "The 3D mesh hasn't been built yet",
    "view2d": "The 2D outputs (orthomosaic · DEM) haven't been built yet",
    "values": "{{dates}}: not calculated because processing hasn't finished yet",
    "issueWrite": "Issue coordinates can't be saved because processing hasn't finished yet",
    "tools3d": "Issue creation and profile measurement are unavailable because processing hasn't finished yet",
    "profile": "Sections can't be viewed because processing hasn't finished yet",
    "coordinates": "Coordinates can't be edited because processing hasn't finished yet",
    "write": "Only viewing is available because processing hasn't finished yet",
  },
  "colorPicker": {
    "changeColor": "Change color: {{target}}",
  },
  "folder": {
    "newFolder": "New folder",
    "newFolderNamed": "New folder in {{name}}",
    "createChild": "New subfolder",
    "rename": "Rename",
    "duplicate": "Duplicate",
    "duplicating": "Copying…",
    "move": "Move",
    "moveToFolder": "Move to folder",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "delete": "Delete",
    "cancel": "Cancel",
    "root": "Top level",
    "moveTargets": "Move to",
    "nameInput": "Folder name",
    "saveName": "Save name",
    "cancelName": "Cancel editing",
    "itemCount": "{{count}} items",
    "folderMenu": "Folder menu: {{name}}",
    "itemMenu": "Item menu: {{name}}",
    "lock": "Lock",
    "unlock": "Unlock",
    "lockedRow": "Locked: {{name}}",
    "showToggle": "Show folder: {{name}}",
    "sizePartial": "{{size}} or more",
    "deleteTitle": "Delete folder",
    "deleteMessage": "Delete the folder '{{name}}'?",
    "deleteMessageWithSubfolders": "Delete '{{name}}' and its subfolders ({{count}} folders in total)?",
    "deleteSubMessage": "{{count}} item(s) inside will move out of the folder. No data is deleted.",
    "deleteSubMessageWithItems": "The {{count}} items inside will also be deleted.",
    "deleteSubMessageNoItems": "The folder has no items, so only the folder is deleted.",
    "loadFailedNamed": "Failed to load the {{name}} folders",
    "selectedCount": "{{count}} selected",
    "selectionHint": "Drag them together into one folder",
    "selectionMaxed": "That is the maximum that can move at once",
    "clearSelection": "Clear selection",
    "error": {
      "forbidden": "You don't have permission to change folders.",
      "notFound": "The folder or item no longer exists. Reloading the list.",
      "failed": "The folder action failed.",
      "notSent": "The folder action wasn't sent. Please try again in a moment.",
      "uploadNotPlaced": "The uploaded files couldn't be placed in the folder, so they were left at the top level.",
      "moveTooMany": "You can move up to {{max}} items at once. Uncheck some and drag again."
    }
  },
  "projects": {
    "projectInfo": "Project Information",
    "application": "Applications",
    "projectList": "Project List",
    "checkingApplication": "2D(Image) & 3D(Model) Inspection",
    "portinfraApplication": "Port Infrastructure Inspection",
    "slopeAppication": "Cut Slope Maintenance",
    "constructingApplication": "Construction Site Management",
    "cadastralApplication": "Land Map Management(Beta)",
    "managingDroneImages": "UAV Image",
    "droneImages": "UAV Image Mapping Process",
    "summaryMapping": "Processing Summary",
    "waitingMapping": "Before Mapping Process",
    "managingProjectGroup": "Grouping Projects",
    "managingEtcData": "Additional Data",
    "roadIssue": "Road pavement issue detection",
    "newProject": "New Project",
    "newProjectCreate": "Create New Project",
    "droneImagesCount": "Image Number",
    "droneImageMapping": "Image Mapping",
    "imageMapingProcess": "Image Mapping Process",
    "processCondition": "Processing Status",
    "orthomosaicDown": "Orthomosaic Map[TIF]",
    "pointcloudDown": "3D Point Clouds[LAS]",
    "meshDown": "3D Mesh[OBJ]",
    "dsmDown": "Digital Surface Model[TIF]",
    "dataDown": "Downloading Image Mapping Results",
    "message": {
      "failedCreatingContent": "Post Creation Failed",
      "deletedContent": "Post Deletion Completed ",
      "failedDeletedContent": "Post Deletion Failed",
      "makeSureDeleteProject": "Are you sure you would like to delete the project?",
      "makeSureDeleteTimeSeries": "Are you sure you would like to delete the time series?",
      "warningDeleteTimeSeries": "This action cannot be undone. \n Deleting a time series will remove all associated data, including issue and measurement records, reports, and other information, permanently.",
      "processingMapping": "You are able to check it when the image mapping process is completed",
      "processingMappingDownload": "You are allowed to download those files when the image mapping process is completed",
      "accessDeniedAdmin": "Administration account cannot be accessed",
      "makeSureModifyProject": "Are you sure you would like to edit the project?",
      "makeSureDeleteFolder": " Are you sure you would like to delete the folder",
      "successUpload": "Uploading Completed",
      "failedUpload": "Uploading Failed",
      "uploadedImage": "Uploaded images",
      "refreshAfterUploaded": "Please refresh section through a button",
      "imageDeleteCompleted": "Image was deleted",
      "imageUpload10": "At least 10 images must be uploaded.",
      "notSelectedImage": "Nothing was selected",
      "deleteCompleted": "deleted",
      "failedDeleting": "Failed Delete",
      "typeProjectName": "Please enter the project name.",
      "deleteTimeSeries": "Delete Time Series",
      "ifYouWantToDeleteTimeSeries": "If you want to delete the time series, please enter ",
      "addTimeSeries": "Add Time Series",
      "duplicateTimeSeries": "Time series already exists for this date.",
      "failedCreating": "Creation Failed",
      "successCreating": "Creation Completed"
    }
  },
  "auth": {
    "message": {
      "loginFailed": "Login failed.",
      "confirmFailed": "Confirmation is Failed",
      "resendingConfirmationCode": "Confirmation code is resend",
      "confirmationCodeResendingFail": "Resending is Failed",
      "fillEmail": "Please enter the email you used for registration.",
      "sendCodeNumber": "We will send you an authentication code.",
      "sentCodeNumber": "The authentication code has been sent.",
      "sendCodeNumberFailed": "Failed to send authentication code.",
      "changePassWordFailed": "Failed to change password.",
      "notMatchCode": "The authentication code consists of six digits."
    }
  },
  "inspection2d": {
    "projectInfo": "Project Information",
    "projectModify": "Editing",
    "layerInfo": "Layers",
    "issueInfo": "Annotations",
    "managingBim": "BIM Management",
    "report": "Report",
    "mainLayer": "Primary Layer",
    "issueType": "Tools",
    "issueName": "Name",
    "createIssue": "Confirmation",
    "typeByXY": "X-Y Coordinate",
    "typeByLatLng": "Lat-Long Coordinate",
    "issueList": "Types",
    "issueDegree": "Quantity Level",
    "msg": {
      "nonNegativeNumber": "Height must be a non-negative number.",
      "tooSmallArea": "Too small area for calculate.",
      "notAnyMatchIssue": "There are no matching issues.",
      "makeIssue": "Please register an issue.",
      "annotaionFixSuccess": "Annotation Editing Completed",
      "nonAnnotation": "No selected annotation or server communication error",
      "projectLoading": "Loading Project",
      "notMyProject": "Not Permitted",
      "layerLoading": "Loading Layer",
      "creationAnnotation": "Annotation Creation Completed",
      "failedCreationAnnotation": "Annotation Creation Failed",
      "loadingFilterInfo": "Loading Filtering Information",
      "successDeleting": "Deletion was successful",
      "failedDeleting": "Deletion was unsuccessful",
      "loadingLongitudianlInfo": "Generating Elevation Profile",
      "outOfRangeMessage": "Out of range",
      "loadingIssuelInfo": "Loading Issue Information",
      "errorLoadLongitudinalInfo": "Elevation profile is not displayed",
      "loadingPage": "Loading the Page",
      "loadingData": "Loading the Data",
      "loadingAnnotation": "Loading the Annotation",
      "checkPositionByClickingMap": "Click on the map to check the coordinates.",
      "loadingMeasurementInfo": "Loading measurement information.",
      "noMeasure": "No measurement information is available.",
      "noLength": "No height information is available.",
      "noDSM": "No DSM information is available.",
      "noLayer": "No Layer is available.",
      "pleaseSelectACrossSection": "select section",
      "noCrossSection": "Out of the target area.",
      "validateStepDigit": "Please enter 2 integers and no more than 1 decimal place.",
      "validateStepLength": "Please enter an interval smaller than the length of each line segment.",
      "longitudinalIntervalError": "Please enter a longitudinal cross-section interval of at least 1 m.",
      "longitudinalWidthError": "The left and right width must be greater than the point interval.",
      "startOverEnd": "Start date is after end date.",
      "endBeforeStart": "End date is before start date.",
      "createdOverStart": "The start date is before the project creation date.",
      "loading3DTiles": "Loading the mesh model...",
      "loading3DTilesError": "Failed to load the mesh model."
    }
  },
  "inspection3d": {
    "layers": "Layers",
    "model": "Model",
    "issue": "Issue",
    "measure": "Measure",
    "profile": "3D Profile",
    "distance": "Distance",
    "lowQuality": "Low Quality",
    "highQuality": "High Quality",
    "opacity": "Opacity",
    "msg": {
      "underMaintenance": "Under maintenance",
      "loading3DModel": "Creating 3D model",
      "modelServerError": "3D model server error.",
      "modelError": "Failed to create 3D model.",
      "syncLayer": "Synchronizing layer info.",
      "syncLayerError": "Synchronization Failed.",
      "noModel": "No generated model found.",
      "noIssues": "No issues.",
      "syncIssues": "Syncing issues.",
      "issueLoadError": "Failed to load issues.",
      "issueCreationSuccess": "Issues created successfully.",
      "issueCreationError": "Failed to create issues.",
      "issueSaveSuccess": "Issues saved successfully.",
      "issueSaveError": "Failed to save issues.",
      "issueDeleteSuccess": "Issues deleted successfully.",
      "issueDeleteError": "Failed to delete issues.",
      "issueAreaError": "Issues can only be created within the model area.",
      "profileAreaError": "Profile can only be created within the model area.",
      "imageAreaError": "Images can only be viewed within the model area.",
      "measurementAreaError": "Measurement can only be created within the model area.",
      "twoPointCountError": "Please create at least two points.",
      "threePointCountError": "Please create at least three points.",
      "rightClickHint": "Right-click to cancel",
      "doubleClickConfirm": "Double-click to confirm",
      "profileSectionSummary": "{{count}} sections · total {{length}} m",
      "leftClickRemove": "Left-click to remove",
      "clickToLoadImage": "Click to check the nearby image",
      "profileCoordinateLoading": "Calculating coordinates",
      "measurementRightClick": "Right-click to finish.",
      "getNearbyImages": "Get nearby images",
      "switchingTimeSeries": "Switching time series...",
      "loadingModelList": "Checking model list...",
      "loadingModelInfo": "Loading 3D model info...",
      "loadingModelTiles": "Rendering 3D model...",
      "meshLoadFailed": "Failed to load model {{name}}",
      "meshLoadStalled": "Some data failed to load",
      "meshLoadStalledNamed": "Failed to load data: {{names}}",
      "meshLoadAllFailed": "Failed to load 3D model",
      "retry": "Retry",
      "loadingBim": "Loading BIM...",
      "loadingPointCloud": "Loading point cloud...",
      "loadingGisLayers": "Loading GIS layers...",
      "loadingLinearLayers": "Loading linear layers...",
      "stageBim": "BIM",
      "stagePointCloud": "Point cloud",
      "stageGis": "GIS layers",
      "stageLinear": "Linear layers",
      "stageLoadFailed": "Failed to load {{name}} — skipping",
      "stageLoadStalled": "Loading {{name}} is taking too long — skipping",
      "layerLoadFailed": "Failed to load the {{name}} layer"
    },
    "measureAxis": {
      "axisSolid": "3D",
      "axisPlane": "2D",
      "axisHeight": "Height",
      "axisHorizontal": "Horizontal",
      "axisSolidArea": "3D area",
      "axisPlaneArea": "2D area"
    },
    "tooltip": {
      "showHide": "Show/Hide",
      "flyToLayer": "Fly to model",
      "flyToMesh": "Fly to model",
      "adjustOpacity": "Adjust opacity",
      "help": {
        "showHide": "Show/Hide layer",
        "flyToLayer": "Fly to model",
        "adjustOpacity": "Adjust opacity"
      }
    }
  },
  "mapTool": {
    "guide": {
      "button": {
        "click": "Click",
        "doubleClick": "Double-click",
        "rightClick": "Right-click",
        "release": "Release",
        "drag": "Drag",
        "clickPlus": "Click (＋)",
        "rightClickPoint": "Right-click (point)"
      },
      "action": {
        "createPoint": "Add point",
        "finish": "Finish",
        "cancel": "Cancel",
        "undo": "Undo",
        "removeMeasurement": "Delete measurement",
        "nearbyImage": "Check nearby image",
        "placeEquipment": "Place",
        "movePoint": "Move point",
        "removePoint": "Remove point",
        "appendPoint": "Add point at end"
      },
      "precisePending": "Creating precise point…"
    }
  },
  "graph": {
    "checkCrossSection": "Check Cross Section",
    "checkLongitudeSection": "Check Elevation Profile",
    "openSectionGraph": "Open section graph: {{target}}",
    "height": "height",
    "distance": "distance",
    "line": "Linear",
    "alignment": "Alignment",
    "lineLayerNotFound": "Line data for the selected layer could not be found. Please contact the administrator.",
    "layerToggleFailed": "Failed to toggle layer",
    "layerColorChangeFailed": "Failed to change layer color",
    "stratum": "stratum",
    "designHeight": "design Height",
    "check": "Check",
    "longitudeSection": "Elevation profile",
    "specificSection": "specific",
    "crossSection": "Cross Section",
    "crossSectionList": "Cross Section",
    "perpendicularInterval": "Cross Interval",
    "pointInterval": "point Interval",
    "pointSetting": "Set up a point",
    "detailSetting": "Detailed settings",
    "startPoint": "start Point",
    "endPoint": "end Point",
    "section": "section",
    "sectionStartPoint": "start Point",
    "sectionEndPoint": "end Point",
    "original": "original",
    "detail": "detailed",
    "startPointError": "The starting station cannot be smaller than the default value",
    "enterBranch": "Please enter a branch",
    "validate": {
      "dxfSaveFileDownloadError": "An error occurred while downloading the file. Please try again.",
      "dxfSaveFileGenerateNotice": "You have been requested to create an file. It's usually done within 10 minutes. Please check it out in a moment.",
      "dxfSaveFileGenerateError": "Failed to create file. Please try again in a moment.",
      "noSavedData": "No data has been saved.",
      "failDeleteData": "Failed to delete data. Please try again.",
      "savePerpendicular": "The cross-section has been saved.",
      "deletePerpendicular": "The cross-section has been deleted.",
      "existingCrossSection": "A cross-section has already been saved. Please delete it and try again.",
      "longitudinalPointIntervalMinValue": " must be at least 1.",
      "perpendicularIntervalMinValue": " must be at least 1.",
      "perpendicularWidthMinValue": " must be at least 1.",
      "duplicatePointError": "Duplicate points detected. Please check for duplicate points.",
      "endPointInfo": "If the end point is not specified or if it is longer than the linear length, the entire cross-section will be displayed.",
      "lngStartPoint": "The start point of the cross-section is only reflected in the TEXT file.",
      "startStepError": "The starting station cannot be smaller than the default value",
      "endStepError": "The end point cannot be smaller than the start point.",
      "sameStepError": "The start and end points cannot be the same.",
      "performanceWarning": "The browser may freeze depending on your computer's performance. If it freezes, please refresh and increase the point interval or reduce the section range.",
      "maxStratumFilesSelected": "You can select up to three files only.",
      "maxStep": "The value must be less than or equal to 100.",
      "increment": "The value must be a multiple of 5",
      "equal": "The point interval must be equal to or less than the cross interval.",
      "setPoint": "Please set the starting point and the endpoint.",
      "pointAdditionError": "The additional point cannot be smaller than the starting point.",
      "pointAdded": "A specific cross-section has been added.",
      "pointAdditionFailed": "Failed to add a specific cross-section. Please try again later.",
      "pointAdditionTargetFailed": "The cross section already exists on this street. Please check the specific street.",
      "distanceExceedsSegmentLength": "The entered distance exceeds the length of the segment.",
      "crossSectionDeletionFailed": "Failed to delete the cross-section. Please try again later."
    }
  },
  "myPage": {
    "accountInfo": "Account Information",
    "quit": "Membership Withdrawal",
    "quitAgreement": " Membership Withdrawal Agreement",
    "quitAggrementDescription": {
      "first": "The user’s personal information is promptly disposed of when the purpose of collecting and using the information is achieved. However, the personal information that must be retained under other laws is stored separately for the valid period and then disposed",
      "second": "First, Disposal Procedure and Deadline: personal information collected and used for its intended purpose will be promptly disposed once its purpose is achieved. If, by law or internal regulations, it needs to be retained for a certain period, it will be securely stored in a separate database and then will be destroyed without delay after the specified certain period. Personal information transferred to the database will not be used for any other purposes, except as required by law",
      "third": "Second, Disposal Method: electronic information in file format will be completely deleted using technically irreversible methods to prevent recovery and regeneration. Personal information printed on paper will be destroyed through shredding or incineration",
      "fourth": "I have reviewed all the instructions and hereby give my consent"
    },
    "msg": {
      "atLeastOneSpecialCharacter": "The password must contain at least one special character.",
      "atLeastOneDigit": "The password must contain at least one number.",
      "passwordLength": "Password must be at least 8 characters long.",
      "atLeastOneLowerCaseLetter": "The password must contain at least one lowercase letter.",
      "passwordNeedCapital": "Password must contain at least one uppercase letter.",
      "onlyNumber": "Type only numbers",
      "notEnoughLength": "Wrong length of numbers.",
      "checkVerifyingEmail": "Please enter the authentication number sent by mail.",
      "makeSureQuiteQuestion": "Would you like to withdraw your membership?",
      "makeSureQuitDoubleCheck": {
        "ko": "회원 탈퇴를 원하신다면, '계정 삭제' 를 입력해 주세요.",
        "en": "If you wish to withdraw your membership, please enter &quot;Account Deletion",
        "checkWord": "Account Deletion"
      },
      "checkDuplicatedEmail": "Please check the duplicated Email.",
      "idAllowEngNumber": "Enter the correct email format.",
      "emailAlreadyExists": "Email already exists",
      "newtworkError": "Duplicated verification is currently not possible due to a network error.",
      "usableEmail": "Available Email",
      "notMatchPassword": "Passwords do not match.",
      "failedModifiedUser": "Failed to update member information",
      "warningTypicalform": "Please enter the content with the specific format",
      "warningQuitDescription": "Please confirm and agree to the withdrawal instructions",
      "joinCompleted": "Your registration is completed",
      "accountDeleted": "Your account has been deleted"
    }
  },
  "userManagement": {
    "manageProjectPermission": "Manage Project Permission",
    "addUser": "Add a user",
    "delete": "Delete",
    "joinStatus": "Join Status",
    "joined": "joined",
    "unjoined": "unjoined",
    "msg": {
      "userAdding": "Proccessing...",
      "userAdded": "The user was added",
      "userDeleted": "The user was deleted",
      "userEdited": "User permissions have been modified.",
      "confirmUserDelete": "Are you sure you want to delete the user from the project?",
      "errorUserEdit": "To modify the role is currently not possible due to a network error.",
      "errorUserDelete": "To delete the user is currently not possible due to a network error.",
      "projectFirst": "Please create a project first",
      "projectsListing": "Loading..."
    }
  },
  "header": {
    "service": "Service",
    "platform": "Platform",
    "survey": "Survey",
    "plan": "Plan",
    "contact": "Contact",
    "manual": "Manual",
    "project": "Project",
    "myPage": "MyPage",
    "auth": {
      "login": "Sign In",
      "logging": "Logging in...",
      "logout": "Sign Out",
      "join": "Sign Up",
      "sendingcode": "Sending code..",
      "changepw": "Change Password",
      "changingpw": "Changing Password...",
      "verifyemail": "Verify Email"
    }
  },
  "sideNav": {
    "error": {
      "nonProject": "Please select a project"
    }
  },
  "constants": {
    "text": "Text",
    "polygon": "Polygon",
    "rectangle": "Rectangle",
    "marker": "Marker",
    "severity": "Severity",
    "importance": "Priority",
    "urgenty": "Urgency",
    "imageupload": "Upload image",
    "checkall": "Check All",
    "distance": "Distance",
    "height": "Elevation",
    "pointBim": "Point Cloud",
    "image": "Image",
    "optimizedImage": "(Optimized/Total)",
    "video": "Video",
    "document": "Document",
    "layer": "Layer",
    "noLayer": "No selectable layers available.",
    "layerSelect": "Please choose a layer.",
    "projectName": "Name",
    "project": "Project",
    "address": "Address",
    "position": "Coordinate(Lat-Lng)",
    "infraType": "Infrastructure",
    "goBack": "Go Back",
    "opacity": "Transparency",
    "loadingCalInfo": "Loading Measurement Information",
    "searchAddress": "Search Address",
    "requiredValue": "This field is mandatory",
    "handsOnWriting": "Enter manually",
    "updatedDate": "Modification",
    "completedDate": "Completion Date",
    "completed": "Completed",
    "objectType": "Object",
    "memo": "Note",
    "tag": "Tags",
    "keyword": "Keywords",
    "cancel": "Cancel",
    "save": "Save",
    "makeIssueTitle": "Please enter an issue title.",
    "modify": "Edit",
    "other": "Others",
    "deleting": "Deletion",
    "delete": "Delete",
    "search": "Search",
    "add": "Add",
    "remove": "Removal",
    "issueList": "Issue List",
    "type": "Type",
    "beforeProcess": "Before Processing",
    "processing": "Processing",
    "processCompleted": "Processed",
    "processFailed": "Processing Failure",
    "twoDimensionImage": "2D Image",
    "threeDimensionImage": "3D Image",
    "requestedProcess": "Processing Request",
    "checkingRequest": "Under Review",
    "coordinateSystem": "Output Coordinate System",
    "resolution": "Ground Sample Distance(GSD)",
    "download": "Download",
    "update": "Update",
    "downing": "Downing",
    "checking": "Checking",
    "createFile": "Create a file",
    "creating": "Creating",
    "group": "Group",
    "preview": "Preview",
    "none": "None",
    "edit": "Edit",
    "editModeMeasureNotice": "Calculated values will update when you exit edit mode",
    "volumeCalculationFailed": "Volume calculation failed. Please try again.",
    "orthomosaicImage": "Orthomosaic Image",
    "gisLayer": "GIS Layer",
    "subLayer": "Secondary Layer",
    "annotation": "Annotation",
    "latitude": "Latitude",
    "latitudeShorten": "Lat",
    "longitude": "Longitude",
    "longitudeShorten": "Lng",
    "location": "Position",
    "create": "Creation",
    "annotationType": "Type",
    "issueDescription": "Anomaly List",
    "issueDegree": "Category",
    "issueGrade": "Quantity Level",
    "createIssue": "Creation",
    "date": "Date",
    "createdDate": "Created Date",
    "reset": "Reset",
    "check": "Confirmation",
    "filtering": "Filtering",
    "totalIssue": "Total issue",
    "cases": " cases",
    "measurement": "Measurement",
    "information": " Information",
    "coordinates": "Coordinates",
    "area": "Area",
    "surfaceArea": "Surface Area",
    "line": "Line",
    "length": " Length",
    "elevationDifference": "Elevation difference",
    "slope": "Slope",
    "volume": "Volume",
    "setFloorHeight": "floor height(m)",
    "volumeCalculate": "Calculate",
    "volumeBaseMode": "Base surface",
    "baseModeCustom": "Enter base height",
    "baseModeTriangulated": "Boundary triangulation",
    "baseModeMean": "Boundary average height",
    "volumeGuideTitle": "Volume Calculation Guide",
    "volumeGuideOpen": "Open volume calculation guide",
    "close": "Close",
    "baseModeCustomDesc": "Calculates volume against a horizontal plane at the height you enter. Above the plane is cut, below is fill.",
    "baseModeTriangulatedDesc": "Connects the polygon boundary vertices into a triangulated network (TIN) and calculates volume against a base surface that follows the terrain slope.",
    "baseModeMeanDesc": "Calculates volume against a horizontal plane at the average terrain elevation of the polygon boundary vertices.",
    "volumeOutOfRasterBounds": "The measured area is outside the terrain elevation data, so the volume cannot be calculated.",
    "crossSection": "Elevation Profile",
    "sectionAndCrossSection": "Elevation Profile · Cross Section",
    "startingSidePoint": "Starting side point",
    "setSpacing": "Set spacing",
    "checkTheCrossSection": "Check Elevation Profile",
    "cutVolume": "Cut Volume",
    "fillVolume": "Fill Volume",
    "netVolume": "Net Volume",
    "settingInterval": "Setting the interval(m)",
    "startingSurveyPoint": "Starting survey point(m)",
    "checkCrossSection": "Check Elevation Profile",
    "longitudeGraph": "height Profile",
    "longitudeSliderNotice": "You can use the right slider to adjust the amount of data around the point of sudden change in the elevation profile.",
    "longitudeDetailNotice": "Please enter the point interval you wish to see in detail on the graph, and select the start and end points.",
    "perpendicular": "cross section",
    "perpendicularGraph": "cross height Profile",
    "perpendicularWidth": "Width setting",
    "left": "left",
    "right": "right",
    "perpendicularInterval": "crossing interval",
    "longitudeGraphPart": "partial view",
    "longitudeGraphTotal": "full view",
    "total2DLength": "total 2D Length",
    "total3DLength": "total 3D Length",
    "planeDistance": "Horizontal Distance",
    "solidDistance": "3D Distance",
    "surfaceDistance": "Surface Distance",
    "planeArea": "Horizontal Area",
    "solidArea": "3D Area",
    "planeDistanceTooltip": "Straight-line distance projected horizontally, ignoring elevation.",
    "solidDistanceTooltip": "3D straight-line distance between two points, including elevation difference.",
    "surfaceDistanceTooltip": "Actual distance along the terrain (mesh) surface contours.",
    "planeAreaTooltip": "Area projected horizontally, ignoring elevation.",
    "solidAreaTooltip": "Area connecting vertices as flat planes, reflecting elevation differences.",
    "surfaceAreaTooltip": "Actual area following the terrain (mesh) surface contours.",
    "upload": "Upload",
    "totalAmount": "Total Data Size",
    "writer": "Author",
    "organization": "Affiliation",
    "title": "Title",
    "rank": "Position",
    "email": "Email",
    "permission": "Permission",
    "createReport": "Auto-generated Report(pdf)",
    "id": "ID",
    "username": "username",
    "no": "No",
    "phone": "Phone",
    "major": "Field",
    "job": "Role",
    "mypage": "MyPage",
    "heightProfile": "Height Profile",
    "imageList": "Image List",
    "total": "Total",
    "imagesCounting": "Images",
    "all": "All",
    "near": "Near",
    "noneImages": "No Image",
    "loadingImages": "Loading image",
    "requestMapping": "Request",
    "requestCompleted": "Done",
    "password": "password",
    "doubleCheck": "Verify Password",
    "linkPositions": "Link Position 2D & 3D",
    "idDoubleCheck": "Double Check",
    "user": "User",
    "submit": "Submit",
    "resend": "Resend",
    "next": "Next",
    "code": "Code Number",
    "filter": "Filter",
    "apply": "Apply",
    "acquired": "Acquired"
  },
  "pdf": {
    "author": "Author",
    "organization": "Affiliation",
    "rank": "Role",
    "email": "Email",
    "report": " Report",
    "groupAssociations": "Group associations",
    "issue": "Issue",
    "issueName": "Issue Name",
    "count": "",
    "layout": "Layout",
    "summary": "Summary",
    "issueLevel": "Level",
    "issueType": "Type",
    "issuePriority": "Priority",
    "comment": "Comment",
    "acquired": "Acquired",
    "msg": {
      "loadingPdf": "Loading PDF..."
    }
  },
  "pricing": {
    "standard1": "Billed monthly",
    "standard1_2": "(Maintain at least 80% image redundancy)",
    "standard2": "3000 image upload per map ",
    "standard3": "2 times image mapping a month",
    "standard4": "Downloading Image Mapping Results",
    "advanced1": "Flexible negotiation of service options",
    "advanced1_2": "through an annual subscription plan",
    "contactUs": "Contact us",
    "title": "DroneSquare Service Plans",
    "description1": "Monitor your sites with accurate data analytics provided by Dronesquare.",
    "description2": "Realize optimal maintenance.",
    "standard_subtitle": "managing a small number of target objects/sites",
    "advanced_subtitle": "managing a large number of target objects/sites"
  }
} as const;

export default common;
